export default __webpack_public_path__ + "static/media/mozart8.ceb9f532.png";